import React from "react";
import NewsGrid from "@/src/components/companies/NewsGrid";

// Correctly destructure the props object to extract `ticker`
export default function NewsSection({ ticker }) {
  return (
      <NewsGrid ticker={ticker} />
  );
}
